
  export default {
    mounted() {
      this.handleEvent(`download:${this.el.id}`, ({ filename, content, content_type }) => {
        const url = URL.createObjectURL(new Blob([content], { type: content_type }))
        const link = document.createElement("a")
        link.href = url
        link.download = filename
        link.click()
        setTimeout(() => URL.revokeObjectURL(url), 0)
      })
    },
  }
